export const TOOL_CATEGORY_IDS = new Map()
  // @TODO: make it dynamic by adding properties to the knowledge base categories rather than hardcoding the ids
  // HU
  .set('recipes-hu', '10')
  .set('videos-hu', '14')
  .set('baby-first-aid-hu', '1728811421198')
  .set('prenatal-exercises-hu', ['1728811421216'])
  .set('baby-care-hu', '1768331346099')
  .set('relaxation-audio-hu', '1768331346164');
